var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _path15, _path16, _path17, _rect, _path18, _ellipse, _g3, _g4, _path19, _g5, _g6, _g7, _path20, _g8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMayThe4(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "may_the_4_svg__Illustration",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1040",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".may_the_4_svg__cls-1{fill:#f93444}.may_the_4_svg__cls-2{fill:#fa505e}.may_the_4_svg__cls-4{fill:#013133}.may_the_4_svg__cls-5{fill:#165b61}.may_the_4_svg__cls-7{fill:#206f77}.may_the_4_svg__cls-8{fill:#0b464a}.may_the_4_svg__cls-13,.may_the_4_svg__cls-14,.may_the_4_svg__cls-16{stroke-linecap:round;stroke-linejoin:round;fill:none}.may_the_4_svg__cls-16{stroke:#0b464a}.may_the_4_svg__cls-13,.may_the_4_svg__cls-14,.may_the_4_svg__cls-16{stroke-width:16px}.may_the_4_svg__cls-13{stroke:#013133}.may_the_4_svg__cls-14{stroke:#165b61}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-4",
    d: "M747.26 570.07L577.22 666.9l161.05 282.81c1.1-.58 2.21-1.18 3.3-1.81 15.67-8.92 28-20.8 35.96-33.49 3.62-5.77 9.85-9.32 16.66-9.49 14.97-.37 31.48-4.91 47.15-13.83 15.67-8.92 28-20.8 35.96-33.49 3.62-5.77 9.85-9.32 16.66-9.49 14.97-.37 31.48-4.91 47.15-13.83 37.34-21.27 55.75-59.35 41.11-85.05-13.66-23.99-234.95-179.15-234.95-179.15z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-5",
    d: "M316.32 575.62l-79.28 80.07a53.289 53.289 0 00-15.42 37.5v85.17c0 12.76 11.72 22.4 24.2 19.74 24.71-5.26 48.21-17.53 67.31-36.82 50.79-51.29 51.75-133.2 3.19-185.66z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-8",
    d: "M658.47 889.48h100.12c17.83 0 32.31 14.48 32.31 32.31v21.02c0 6.23-5.06 11.29-11.29 11.29H658.47c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z",
    transform: "rotate(-180 708.53 921.785)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M625.16 889.77l1 32.02c0 17.77 14.54 32.31 32.31 32.31h100.12c17.77 0 32.31-14.54 32.31-32.31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-8",
    d: "M334.02 889.48h121.14c6.23 0 11.29 5.06 11.29 11.29v21.02c0 17.83-14.48 32.31-32.31 32.31H334.02c-17.83 0-32.31-14.48-32.31-32.31 0-17.83 14.48-32.31 32.31-32.31z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M465.45 889.77l1 32.02c0 17.77-14.54 32.31-32.31 32.31H334.02c-17.77 0-32.31-14.54-32.31-32.31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-5",
    d: "M774.77 790.2c.19-2.79.3-5.6.3-8.44V460.12c0-63.17-25.61-120.36-67.01-161.76-41.4-41.4-98.59-67-161.76-67-126.34 0-228.76 102.42-228.76 228.76v321.65c0 2.84.1 5.65.3 8.44h456.94z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-8",
    d: "M406.63 636.3h279.35v139.27H406.63zM317.54 776.29v5.48c0 62.9 48.4 114.51 110 119.58 3.29.28 6.63.42 10 .42h217.53c3.37 0 6.71-.14 10-.42 61.59-5.07 110-56.68 110-119.58v-5.48H317.54z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M437.54 901.77h217.53"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-16",
    d: "M317.54 776.29V688.6M775.07 776.29V688.6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M743.17 863.24c19.8-21.4 31.9-50.03 31.9-81.48v-5.48H317.54v5.48c0 31.45 12.1 60.08 31.9 81.48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-4",
    d: "M546.3 231.36c-126.34 0-228.76 102.42-228.76 228.76v121.24c6.1 5.72 12.55 11.21 19.33 16.45 53.6 41.4 127.65 67 209.44 67 92.13 0 174.44-32.49 228.76-83.45V460.11c0-63.17-25.61-120.36-67.01-161.76-41.4-41.4-98.59-67-161.76-67z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M317.54 581.35c6.1 5.72 12.55 11.21 19.33 16.45 53.6 41.4 127.65 67 209.44 67 92.13 0 174.44-32.49 228.76-83.45",
    stroke: "#206f77",
    strokeWidth: 16,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-16",
    d: "M539.18 556.52c-22.57 22.57-53.76 36.54-88.21 36.54s-65.63-13.96-88.21-36.54c-22.57-22.57-36.54-53.76-36.54-88.21s13.96-65.63 36.54-88.21c22.57-22.57 53.76-36.54 88.21-36.54s65.63 13.96 88.21 36.54M553.43 380.1c22.57-22.57 53.76-36.54 88.21-36.54s65.63 13.96 88.21 36.54c22.57 22.57 36.54 53.76 36.54 88.21s-13.96 65.63-36.54 88.21c-22.57 22.57-53.76 36.54-88.21 36.54s-65.63-13.96-88.21-36.54"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "may_the_4_svg__cls-8",
    x: 406.63,
    y: 391.51,
    width: 118.93,
    height: 168.19,
    rx: 59.46,
    ry: 59.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-7",
    d: "M466.09 539.7c-21.76 0-39.46-17.7-39.46-39.46v-49.26c0-21.76 17.7-39.46 39.46-39.46s39.46 17.7 39.46 39.46v49.26c0 21.76-17.7 39.46-39.46 39.46z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "may_the_4_svg__cls-8",
    x: 567.05,
    y: 391.51,
    width: 118.93,
    height: 168.19,
    rx: 59.46,
    ry: 59.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-7",
    d: "M626.52 539.7c-21.76 0-39.46-17.7-39.46-39.46v-49.26c0-21.76 17.7-39.46 39.46-39.46s39.46 17.7 39.46 39.46v49.26c0 21.76-17.7 39.46-39.46 39.46z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-8",
    d: "M453.75 363.15h4.14a81.22 81.22 0 0170.48 40.61l1.04 1.81c7.65 13.24 26.19 13.23 33.6.38l.61-1.06a83.115 83.115 0 0172.02-41.63h3.22c40.2 0 75.37 27.02 85.74 65.86l34.44 129.06c4.67 17.51 20.53 29.69 38.65 29.69h27.04c26.28 0 45.42-24.92 38.65-50.31L825.77 396.6c-33.78-126.59-148.43-214.66-279.45-214.66-131.02 0-245.68 88.07-279.45 214.66l-37.61 140.96c-6.78 25.4 12.36 50.31 38.65 50.31h27.04c18.12 0 33.98-12.18 38.65-29.69l34.44-129.06c10.37-38.85 45.53-65.9 85.74-65.97z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-14",
    d: "M368.01 429.12c10.37-38.85 45.53-65.9 85.74-65.97h4.14a81.22 81.22 0 0170.48 40.61l1.04 1.81c7.65 13.24 26.19 13.23 33.6.38l.61-1.06a83.115 83.115 0 0172.02-41.63h3.22c40.2 0 75.37 27.02 85.74 65.86"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M825.76 396.59C791.98 270 677.33 181.93 546.31 181.93c-131.02 0-245.68 88.07-279.45 214.66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "may_the_4_svg__cls-5",
    x: 515.13,
    y: 142.52,
    width: 62.34,
    height: 278.49,
    rx: 31.17,
    ry: 31.17
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-13",
    d: "M577.48 241.2v-67.51c0-17.14-14.03-31.17-31.17-31.17s-31.17 14.03-31.17 31.17v67.51"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "may_the_4_svg__cls-5",
    cx: 546.31,
    cy: 542.25,
    rx: 62.07,
    ry: 37.65
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-2",
    d: "M500.47 727.96c-13.24 9.45-31.62-.02-31.62-16.28v-55.35c0-16.26 18.38-25.73 31.62-16.28L521 654.7c20.12 14.36 20.12 44.25 0 58.61l-20.53 14.65zM592.14 727.96c13.24 9.45 31.62-.02 31.62-16.28v-27.67-27.67c0-16.26-18.38-25.73-31.62-16.28l-20.53 14.65c-20.12 14.36-20.12 44.25 0 58.61l20.53 14.65z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f93444",
    strokeWidth: 16,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M494.67 684.01h103.27"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "may_the_4_svg__cls-2",
    x: 528.14,
    y: 665.85,
    width: 36.32,
    height: 36.32,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-1",
    d: "M554.47 665.85c5.52 0 10 4.48 10 10v16.32c0 5.52-4.48 10-10 10h-16.32c-5.52 0-10-4.48-10-10v-16.32c0-5.52 4.48-10 10-10h16.32m0-16h-16.32c-14.34 0-26 11.66-26 26v16.32c0 14.34 11.66 26 26 26h16.32c14.34 0 26-11.66 26-26v-16.32c0-14.34-11.66-26-26-26z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "may_the_4_svg__cls-1",
    cx: 448.81,
    cy: 775.57,
    r: 20.63
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 643.81,
    cy: 775.57,
    r: 20.63,
    fill: "#46c65e"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#013133",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#165b61",
    d: "M496.88 751.53h98.84v48.08h-98.84z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-14",
    d: "M232.92 509.11h68.25M244.39 472.1h68.25"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-14",
    d: "M859.69 509.11h-68.25M848.22 472.1h-68.25"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M913.22 617.25l-46.87-39.33c-12.69-10.65-31.61-8.99-42.26 3.7l-33.12 39.48-1.5-16.35c-1.34-15.3-14.96-26.73-30.26-25.39h0c-15.3 1.34-26.73 14.95-25.39 30.26l5.13 57.91c.01.17.04.33.06.49 1.15 15.21 8.14 29.97 20.68 40.49l23.26 19.52c24.69 20.71 61.83 17.46 82.54-7.22l1.3-1.55 4.91-5.85 45.22-53.9c10.65-12.69 8.99-31.61-3.7-42.26z",
    stroke: "#0b464a",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-4",
    d: "M913.22 617.25l-46.87-39.33c-12.69-10.65-31.61-8.99-42.26 3.7l-33.12 39.48-1.5-16.35c-1.34-15.3-14.96-26.73-30.26-25.39-15.3 1.34-26.73 14.95-25.39 30.26l5.13 57.91c.01.17.04.33.06.49 1.15 15.21 8.14 29.97 20.68 40.49l23.26 19.52c24.69 20.71 61.83 17.46 82.54-7.22l1.3-1.55 4.91-5.85 45.22-53.9c10.65-12.69 8.99-31.61-3.7-42.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-16",
    d: "M797.46 601.94l2.71 33.15c9.76 8.61 10.87 23.43 2.5 33.4l-5.57 6.63M876.3 581.34l-38.45 45.83M908.12 608.04l-38.46 45.83M824.83 618.22l55.91 46.91"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 15,
    stroke: "#0b464a",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M515.13 542.25h62.35"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-4",
    d: "M242.23 653.88l-61.04 31.58c-11.6 6-16.11 20.33-10.07 32.01l3.86 7.47 78.17-40.44c5.61-2.9 12.53-.68 15.45 4.97l15.14 29.26c4.43 8.57 14.93 11.94 23.44 7.54 8.51-4.4 11.82-14.92 7.39-23.49l-15.91-30.75c-10.67-20.63-35.94-28.75-56.44-18.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-8",
    transform: "rotate(-27.35 214.833 743.94)",
    d: "M187.81 654.16h53.9v179.3h-53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-5",
    d: "M223.75 833.12l5.7 11.02c1.87 3.61 6.29 5.03 9.88 3.18l45.73-23.66c3.59-1.86 4.98-6.29 3.11-9.9l-5.7-11.02c-1.87-3.61-6.29-5.03-9.88-3.18l-45.73 23.66c-3.59 1.86-4.98 6.29-3.11 9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-4",
    d: "M179.08 675.3h58.07c23.14 0 41.92 18.78 41.92 41.92v50.69c0 23.14-18.78 41.92-41.92 41.92h-58.07c-13.1 0-23.73-10.63-23.73-23.73v-87.07c0-13.1 10.63-23.73 23.73-23.73z",
    transform: "rotate(-27.35 217.272 742.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-16",
    d: "M178.25 686.98l25.88-13.39c10.25-5.3 21.69-5.92 31.9-2.64s19.2 10.47 24.53 20.79l11.58 22.39 11.58 22.39c5.34 10.31 6.01 21.8 2.79 32.03s-10.34 19.21-20.58 24.52l-25.88 13.39M202.45 724.61l52.07-26.94M223.33 764.97l52.07-26.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "may_the_4_svg__cls-1",
    d: "M98.66 359.29c12.59 0 22.82 10.23 22.82 22.82v297.37H75.84V382.11c0-12.59 10.23-22.82 22.82-22.82z",
    transform: "rotate(-27.35 98.69 519.48)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.19,
    y: 652.42,
    width: 83.33,
    height: 24.65,
    rx: 12.29,
    ry: 12.29,
    transform: "rotate(-27.35 173.914 664.854)",
    fill: "#2a848e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.03 622.55c-4.1 2.12-9.15.5-11.29-3.63L38.17 420.67c-2.13-4.13-.54-9.19 3.56-11.31s9.15-.5 11.29 3.63l102.56 198.25c2.13 4.13.54 9.19-3.56 11.31z",
    fill: "#fb7c86"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayThe4);
export default ForwardRef;